import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { CommandService } from '@core/services/command.service';
import { GraphQLService } from '@core/services/graphql.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { InvalidateSmartGridAction } from '@shared/store/actions/smart-grid.actions';
import { DELETE_NOTIFICATIONS, DELETE_NOTIFICATIONS_SUCCESS, DeleteNotificationsAction, DeleteNotificationsFailAction, DeleteNotificationsSuccessAction, TOGGLE_STATE, TOGGLE_STATE_SUCCESS, ToggleStateAction, ToggleStateSuccessAction } from '../actions/notifications.actions';


@Injectable()
export class NotificationsEffects {

  constructor (private actions$: Actions,
               private fuseSplashScreenService: FuseSplashScreenService,
               private snackBarService: SnackBarService,
               private graphQLService: GraphQLService,
               private commandService: CommandService) {
  }

  
  deleteNotifications = createEffect(() => this.actions$
    .pipe(
      ofType(DELETE_NOTIFICATIONS),
      mergeMap((action: DeleteNotificationsAction) => {
        this.fuseSplashScreenService.show();
        return this.commandService.executeCommand(action.command)
          .pipe(
            map((response: any) => {
              this.snackBarService.showInformation('Notifications deleted');
              this.fuseSplashScreenService.hide();
              return new DeleteNotificationsSuccessAction(action.smartGridSourceType);
            }),
            catchError(error => {
              this.snackBarService.showError('Delete Notifications failed');
              this.fuseSplashScreenService.hide();
              return of(new DeleteNotificationsFailAction(error));
            })
          );
      })
    ));

  
  deleteNotificationsSuccess = createEffect(() => this.actions$
    .pipe(
      ofType(DELETE_NOTIFICATIONS_SUCCESS),
      mergeMap((action: DeleteNotificationsSuccessAction) => {
        this.snackBarService.showInformation('Notifications deleted');
        this.fuseSplashScreenService.hide();
        return of(new InvalidateSmartGridAction(action.smartGridSourceType, true, false, false));
      })
    ));

  
  toggleNotificationState = createEffect(() => this.actions$
    .pipe(
      ofType(TOGGLE_STATE),
      mergeMap((action: ToggleStateAction) => {
        this.fuseSplashScreenService.show();
        return this.commandService.executeCommand(action.command)
          .pipe(
            map((response: any) => {
              this.fuseSplashScreenService.hide();
              return new ToggleStateSuccessAction(action.smartGridSourceType);
            }),
            catchError(error => {
              this.snackBarService.showError('Notification state update failed');
              this.fuseSplashScreenService.hide();
              return of(new DeleteNotificationsFailAction(error));
            })
          );
      })
    ));

  
  toggleNotificationStateSuccess = createEffect(() => this.actions$
    .pipe(
      ofType(TOGGLE_STATE_SUCCESS),
      mergeMap((action: ToggleStateSuccessAction) => {
        this.snackBarService.showInformation('Notification state updated');
        this.fuseSplashScreenService.hide();
        return of(new InvalidateSmartGridAction(action.smartGridSourceType, true, false, false));
      })
    ));
}
